import CryptoJS from 'crypto-js'
import { deepClone } from '../tools'
import config from "@/config";

export const decryptPsdData = async (url) => {
    try {
        let response = await fetch(url)
        let json = await response.text()
        // 解密
        const bytes = CryptoJS.AES.decrypt(json, config.psdKey)
        const decryptedString = bytes.toString(CryptoJS.enc.Utf8)
        // 将字符串转换回JSON对象
        let result = JSON.parse(decryptedString)
        return result
    } catch (error) {
        console.error('解密失败:', error)
    }
}

//通用图片加载
export const loadImg = (src) => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = src;
        image.onload = () => resolve(image);
        image.onerror = (error) => reject(error);
        image.setAttribute('crossOrigin', 'anonymous')
    });
}

//生成临时Base64图片
export const createTempCanvas = async (imgs, bg = "", w = 800, h = 800, format = "png") => {
    try {
        let canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        let ctx = canvas.getContext("2d");
        canvas.height = h;
        ctx.clearRect(0, 0, w, h);
        if (bg != "") {
            ctx.fillStyle = bg;
            ctx.fillRect(0, 0, w, h);
        }
        ctx.imageSmoothingEnabled = false;
        for (let img of imgs) {
            let image = await loadImg(img)
            ctx.drawImage(image, 0, 0, w, h);
        }
        let result = canvas.toDataURL(`image/${format || "png"}`)
        canvas.remove()
        return result
    } catch (e) {
        console.log(e);

    }
}

export const dealDesignFaceDatas = (designFaceData, currentSpecName) => {
    const faceData = [];
    const modelParams = {};
    for (const index in designFaceData) {
        const face = designFaceData[index];
        let cloneData = deepClone(face);
        if (cloneData.design_name.indexOf(',') > -1) {
            const design_names = cloneData.design_name.split(',')
            cloneData.design_name = design_names[0]
            cloneData.correlation_face = design_names
        }
        if ([1, 3].indexOf(face.is_diy) > -1) {
            if (cloneData.more_spec == 1) {
                let sku_diy_data = JSON.parse(
                    deepClone(cloneData.sku_diy_data)
                );
                let currentData = sku_diy_data.find(
                    (item) => item.name == currentSpecName
                );
                cloneData = {
                    ...cloneData,
                    ...currentData,
                };
            }
            const {
                design_size,
                production_size,
                crop_size,
                dotted_size,
            } = cloneData;
            const designSize = design_size.split("|");
            cloneData.maxwidth = designSize[0];
            cloneData.maxheight = designSize[1];
            const productionSize = production_size.split("|");
            cloneData.productionWidth = productionSize[0];
            cloneData.productionHeight = productionSize[1];
            const dottedSize = dotted_size.split("|");
            cloneData.dottedWidth = dottedSize[0];
            cloneData.dottedHeight = dottedSize[1];
            cloneData.crop_size = crop_size.split("|");

            cloneData.printquality = "";
            let recommend_size = ["", ""];
            if (cloneData.recommend_size) {
                recommend_size = cloneData.recommend_size
                    ? cloneData.recommend_size
                        .split("x")
                        .map(Number)
                    : ["", ""];
            }
            cloneData.recommend_size = recommend_size;
            cloneData.design_full = 0; //1未铺满2已铺满
            faceData.push(cloneData);
            const modelData = deepClone(face);
            if (modelData.normalmap) {
                const normalmap = JSON.parse(modelData.normalmap);
                modelData.normalMap = {
                    img: normalmap.img,
                    repeat: normalmap.repeat,
                    scale: normalmap.scale,
                };
            } else {
                modelData.normalMap = null;
            }
            modelData.default_texture = modelData.texture;
            modelParams[face.design_name] = modelData;
        } else {
            if (cloneData.normalmap) {
                const normalmap = JSON.parse(cloneData.normalmap);
                cloneData.normalMap = {
                    img: normalmap.img,
                    repeat: normalmap.repeat,
                    scale: normalmap.scale,
                };
            } else {
                cloneData.normalMap = null;
            }
            modelParams[face.design_name] = cloneData;
        }
    }
    return {
        faceData,
        modelParams,
    };
}




//type 1 模型 2 纹理
export const getTempTexture = ({ type, canvas, layerData, designFaceShiftX, designFaceShiftY, canvasW, canvasH, zoomScale }) => {
    let img = ''
    if (type == 1) {
        let scale = 800;
        img = canvas.toDataURL({
            left: designFaceShiftX,
            top: designFaceShiftY,
            width: canvasW * zoomScale,
            height: canvasH * zoomScale,
            multiplier: scale / (canvasW * zoomScale),
            format: "png",
        });
    } else {
        const value = layerData.CL ? layerData.CL.find((i) => i.T == 'SmartObject') : layerData
        const OS = value.OS
        let left = designFaceShiftX;
        let top = designFaceShiftY;
        let canvasWidth = canvasW * zoomScale
        let canvasHeight = canvasH * zoomScale
        let scale = 1
        if (OS[0] > OS[1]) { // 宽度大于高度
            scale = OS[0] / canvasWidth
            top += canvasHeight * (1 - OS[1] / OS[0]) / 2
            canvasHeight = canvasWidth * (OS[1] / OS[0])
        } else {
            scale = OS[1] / canvasHeight
            left += canvasWidth * (1 - OS[0] / OS[1]) / 2
            canvasWidth = canvasHeight * (OS[0] / OS[1])
        }
        img = canvas.toDataURL({
            left: left,
            top: top,
            width: canvasWidth,
            height: canvasHeight,
            multiplier: scale,
            format: "png",
        });
    }
    return img
}

export const getTempTextureFactory = ({ canvas, layerData, designFaceShiftX, designFaceShiftY, canvasW, canvasH, zoomScale }) => {
    const value = layerData.CL ? layerData.CL.find((i) => i.T == 'SmartObject') : layerData
    const OS = value.OS
    let left = designFaceShiftX;
    let top = designFaceShiftY;
    let canvasWidth = canvasW * zoomScale
    let canvasHeight = canvasH * zoomScale
    const widthArr = canvas.getObjects('.customize').map(item => item.width)
    let scale = 1
    if (OS[0] > OS[1]) { // 宽度大于高度
        scale = OS[0] / canvasWidth
        top += canvasHeight * (1 - OS[1] / OS[0]) / 2
        canvasHeight = canvasWidth * (OS[1] / OS[0])
    } else {
        scale = OS[1] / canvasHeight
        left += canvasWidth * (1 - OS[0] / OS[1]) / 2
        canvasWidth = canvasHeight * (OS[0] / OS[1])
    }
    if (canvasWidth * scale < 7000) {
        if (Math.max(...widthArr) > OS[0]) {
            scale *= Math.max(...widthArr) / OS[0] > 2 ? 2 : Math.max(...widthArr) / OS[0]
        }
    }
    let img = canvas.toDataURL({
        left: left,
        top: top,
        width: canvasWidth,
        height: canvasHeight,
        multiplier: scale,
        format: "png",
    });
    return img
}

export const isDesignFace = (value) => {
    return (
        value["is_diy"] == 1 &&
        value["content_type"] != 4 &&
        value["content_type"] != 5
    );
}

export const getDesignFace = (face, indexArr) => {
    if (indexArr && indexArr.length > 0) {
        return face.filter((item, index) => isDesignFace(item) && indexArr.includes(index))
    } else {
        return face.filter((item, index) => isDesignFace(item))
    }
}